<mat-icon class="col-md-12" class="close-button" (click)="onModalCancel()" color="primary">cancel</mat-icon>

<div>
    <h5 style="text-align: center  !important;">{{message}}</h5>

</div>
<div mat-dialog-content>
    <div>

        <div class="col-md-12">
            <app-fixed-lettrage-bp-array class="row" [form]="form" (onLinckClick)="close($event)">
            </app-fixed-lettrage-bp-array>
        </div>

    </div>
</div>